import React, { useContext, useState } from 'react'
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import AtomicButton from '../../atomic/button/Button';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Dialog } from '@mui/material'
import { OrderDataProviderContext } from '../../context-api/data-provider/OrderDataProvider';
import { isMobile, isIpad, isDesktop } from '../../utils/ScreenSizeHelper';


const UpdateOrderTime = (props) => {

    const { HandleAcceptSubmit } = props
    const {
        isLoggedIn,
        selectedMenuTab,
        setSelectedMenuTab,
        setisLoggedIn, newPendingOrder, setNewPendingOrder,
        preparingOrder, setPreparingOrder,
        scheduledOrder, setScheduledOrder,
        openOrderAlert, setOpenOrderAlert,
        allOrders, setAllOrders,
        openUpdateTimeDialog, setOpenUpdateTimeDialog,
        openSnackBar, setOpenSnackBar

    } = useContext(GlobalStateDataContext)

    const { onUpdateOrderStatus, updateOrderAPIResponse, setUpdateOrderAPIResponse, getOrderAPIResponse,
        FetchOrders, clickedOrder, setClickedOrder } = useContext(OrderDataProviderContext)

    const { loading, success, message, data, } = getOrderAPIResponse
    const { loading: isLoading, success: isSucess, message: isMessage, data: isData } = updateOrderAPIResponse

    const cookingTime = 1
    const [count, setCount] = useState(cookingTime);

    const [disableIncrementBtn, setDisableIncrementBtn] = useState(false)
    const [disableDecrementBtn, setDisableDecrementBtn] = useState(count === cookingTime)

    const handleClose = (event, reason) => {

        setOpenSnackBar({
            ...openSnackBar,
            warning: false,
            open: false,
            snakBarMessage: ''
        });

        if (reason === 'clickaway') {
            return;
        }

    };



    const increment = () => {

        if (count < 30) {
            setCount(prev => prev + 1);
            if (count === cookingTime) {
                setDisableDecrementBtn(false)
            }
        } else {
            setDisableIncrementBtn(true)
        }

    };

    const decrement = () => {

        if (count > cookingTime) {
            setCount(prev => prev - 1);
            if (count === 30) {
                setDisableIncrementBtn(false)
            }
        } else {
            setDisableDecrementBtn(true)

        }

    };

    const HandleUpdateTimeOrder = async () => {

        setOpenSnackBar({
            ...openSnackBar,
            warning: false
        });


        if (count > cookingTime) {
            const payload = {
                order_no: clickedOrder?.order_no,
                user_type: "kitchen",
                operation: "update delivery time slot",
                update_cooking_time: count

            }

            const checkResp = await onUpdateOrderStatus(payload)

            if (checkResp?.success && checkResp?.message === "Delivery time slot updated successfully!") {
                setOpenSnackBar({
                    ...openSnackBar,
                    open: true,
                    warning: false,
                    snakBarMessage: "Successfully updated time"
                });
                // Accept order
                HandleAcceptSubmit()
                setOpenUpdateTimeDialog(false)

            } else {
                setOpenSnackBar({
                    ...openSnackBar,
                    open: true,
                    warning: true,
                    snakBarMessage: "Time cannot be updated at this stage"
                });
                setOpenUpdateTimeDialog(false)
            }

        }
    }


    return (
        <Dialog
            open={openUpdateTimeDialog}
            onClose={handleClose}  // This will close dialog if it clicked anywhere on screen
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="alert-dialog-wrapper"
        >

            <div style={{
                display: 'flex',
                // justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: 'calc(90vw - 0px)',
                marginTop: '10%',
                // overflowY: 'none',
                // height: '80%',
                height: '100vh'
            }}>

                <div style={{ fontSize: '20px', marginBottom: '10px' }}> Ready Time</div>


                <AccessTimeIcon sx={{ color: '#181436', fontSize: '100px', margin: '0px 5px 0px 0px' }} />

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    padding: '10px',
                    marginBottom: '2%'
                }}>
                    <button disabled={disableDecrementBtn}
                        onClick={decrement}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '30px',
                            height: '40px',
                            width: '40px',
                            borderRadius: '20px',
                            border: 'none',
                            color: disableDecrementBtn === false ? 'white' : 'gray',
                            backgroundColor: disableDecrementBtn === false ? 'black' : 'lightgray',
                            fontSize: '20px',
                        }}>-</button>
                    <div >{count} min</div>
                    <button disabled={disableIncrementBtn}
                        onClick={increment}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: '30px',
                            height: '40px',
                            width: '40px',
                            borderRadius: '20px',
                            border: 'none',
                            color: disableIncrementBtn === false ? 'white' : 'gray',
                            backgroundColor: disableIncrementBtn === false ? 'black' : 'lightgray',
                            fontSize: '20px',
                        }}>+</button>

                </div>


                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    width: '100%',
                }}>


                    <AtomicButton
                        label="Cancel"
                        handleSubmit={() => { setOpenUpdateTimeDialog(false); setCount(cookingTime) }}
                        style={{
                            backgroundColor: '#fff4e7',
                            width: isIpad ? '15%' : "125px",
                            marginRight: '10px',
                            color: 'gray'
                        }}
                        loading={false}
                        disabled={false}
                    />
                    <AtomicButton
                        label="Accept and update time"
                        handleSubmit={HandleUpdateTimeOrder}
                        style={{
                            color: 'white',
                            backgroundColor: 'rgb(24, 20, 54)',
                            width: isIpad ? '25%' : "250px",
                            margin: '0px',
                            margin: '0px 5px 0px 10px'
                        }}
                        loading={loading || isLoading}
                        disabled={(count === cookingTime || loading || isLoading)}
                    />
                </div>


            </div>

        </Dialog>

    )
}

export default UpdateOrderTime